export default [
  // tablero
  {
    title: "Tablero",
    icon: "fa-house",
    fontAwesome: true,
    tagVariant: "light-warning",
    route: "home",
    resource: "Home",
    action: "read",
  },

  {
    title: "Productos",
    icon: "fa-boxes-packing",
    route: "productos.promocionales",
    fontAwesome: true,
    action: "read",
    resource: "Productos promocionales",
  },

  {
    title: "Materiales Promocionales",
    icon: "fa-bullhorn",
    fontAwesome: true,
    route: "materiales.promocionales",
    action: "read",
    resource: "Materiales promocionales",
  },

  {
    title: "Mis Cupones",
    icon: "fa-ticket",
    fontAwesome: true,
    route: "mis.cupones",
    action: "read",
    resource: "Cupones",
  },

  {
    title: "Retiros",
    icon: "fa-money-bill-transfer",
    route: "retiros.list",
    fontAwesome: true,
    action: "read",
    resource: "Retiros",
  },

  {
    title: "Salón de los Inmortales",
    route: "salon.inmortales",
    action: "read",
    resource: "Salón de los Inmortales",
    icon: "fa-trophy",
  },

  {
    title: "Ayuda & Entreno",
    route: "soporte",
    action: "read",
    resource: "Soporte",
    icon: "fa-life-ring",
  },

  // {
  //   title:'Datos para recibir pagos',
  //   route:'datos-pagos.list',
  //   action:'read',
  //   resource:'Datos para recibir pagos',
  //   icon:'fa-money-bill',
  //   fontAwesome: true,
  // },

  // Reportes
  {
    title: "Reportes",
    icon: "fa-rectangle-list",
    fontAwesome: true,
    children: [
      {
        title: "Estado de Cuenta",
        icon: "fa-money-bill-transfer",
        route: "estado.cuentas",
        fontAwesome: true,
        action: "read",
        resource: "Estado de cuentas",
      },
    ],
  },
];